import type { ModelsSupportTicket } from '@/api/generated-api'

const ACTIVE_TICKET_STATUSES = new Set(['OPEN', 'PENDING'])

export function isSupportTicketActiveStatus(
  status: string | undefined
): boolean {
  const normalized = status?.trim().toUpperCase()
  if (!normalized) {
    return false
  }
  return ACTIVE_TICKET_STATUSES.has(normalized)
}

export function hasActiveSupportTicket(
  tickets: ModelsSupportTicket | ModelsSupportTicket[] | undefined
): boolean {
  const list = Array.isArray(tickets) ? tickets : tickets ? [tickets] : []
  return list.some(ticket => isSupportTicketActiveStatus(ticket.status))
}
